import { Grid, TextField } from "@mui/material";
import { AppFrame } from "../components/AppFrame"
import { BottomNav } from "../components/BottomNav";
import { EnterDimFrame } from "../components/EnterDimFrame";
import { useNavigate } from "react-router-dom";
import logo from '../images/JB.png';

export const EnterWK60P2 = () => {

    const navigate = useNavigate();

    const onClickPrev = () => {
        navigate(-1)
    }

    const onClickNext = () => {
        navigate("/outro")
    }

    return (
        <AppFrame>
            <EnterDimFrame instruction="Geben Sie die gemessenen Strecken und Winkel in die WK60 ein">
                <Grid container spacing={4}>
                    <Grid item xs={12}>
                        <TextField id="outlined-basic" label="Strecke J - E [m]" variant="outlined" sx={{ marginTop: 1, width: 150 }} />
                        <TextField id="outlined-basic" label="Winkel J - E [°]" variant="outlined" sx={{ marginTop: 1, width: 150 }} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField id="outlined-basic" label="Strecke J - F [m]" variant="outlined" sx={{ marginTop: 1, width: 150 }} />
                        <TextField id="outlined-basic" label="Winkel J - F [°]" variant="outlined" sx={{ marginTop: 1, width: 150 }} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField id="outlined-basic" label="Strecke J - G [m]" variant="outlined" sx={{ marginTop: 1, width: 150 }} />
                        <TextField id="outlined-basic" label="Winkel J - G [°]" variant="outlined" sx={{ marginTop: 1, width: 150 }} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField id="outlined-basic" label="Strecke J - H [m]" variant="outlined" sx={{ marginTop: 1, width: 150 }} />
                        <TextField id="outlined-basic" label="Winkel J - H [°]" variant="outlined" sx={{ marginTop: 1, width: 150 }} />
                    </Grid>
                </Grid>
                
            </EnterDimFrame>
            <BottomNav onClickPrev={onClickPrev} onClickNext={onClickNext} />

        </AppFrame>
    )
}
